"use client";

import { useState, useEffect } from "react";
import { Check, Mail, User } from "lucide-react";
import link from "../../../../assets/images/link.png";
import facebook from "../../../../assets/images/facebook.png";
import insta from "../../../../assets/images/insta.png";
import { loginWithOtp } from "../../api/Auth/Login/otp";
import { sendOTP } from "../../api/OTP/SendOtpSlice";
import { useDispatch, useSelector } from "react-redux";
import { MobileView } from "react-device-detect";
import login_web from "../../../../assets/images/login_web.png";
import login_mobile from "../../../../assets/images/login_mobile.png";
import left_side_logo from "../../../../assets/images/left_side_logo.png";
import login_card_new from "../../../../assets/images/login_card_new.png";
import laptop from "../../../../assets/images/laptop.png";
import iphone1 from "../../../../assets/images/iphone1.png";
import iphone2 from "../../../../assets/images/iphone2.png";
import back_logo from "../../../../assets/images/back_logo.png";
import login_logo_new from "../../../../assets/images/login_logo_new.png";
export default function Component() {
  const REACT_APP_PRACT = process.env.REACT_APP_PRACT;
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.login);
  const [email, setEmail] = useState("");
  const [userRole, setUserRole] = useState(null); // Store role from sendOTP response
  const [currentView, setCurrentView] = useState("login"); // "login" or "otp"
  const [otpCode, setOtpCode] = useState(["", "", "", "", "", ""]);
  const [countdown, setCountdown] = useState(90); // 1:30 in seconds
  const [bgImage, setBgImage] = useState(login_web);
  const [emailClassName, setEmailClassName] = useState(
    "block w-full pl-10 pr-3 py-3 border-1 border-[#CBD5E1] rounded-[12px] font-poppins text-[#171717] leading-5 bg-[#F8FAFC] placeholder-[#94A3B8] focus:outline-none focus:placeholder-[#334155] focus:ring-1 focus:ring-[#4B61FF] focus:border-[#4B61FF] mt-[20px] mb-[20px]"
  );
  const [emailError, setEmailError] = useState(null);
  const [otpError, setOTPError] = useState(null);
  const [links, setLinks] = useState([
    {
      id: 1,
      image: link,
      width: "24px",
      height: "24px",
      link: "https://www.linkedin.com/uas/login?session_redirect=%2Fcompany%2F100902149",
    },
    {
      id: 2,
      image: facebook,
      width: "24px",
      height: "24px",
      link: "https://www.facebook.com/phybercare",
    },
    {
      id: 3,
      image: insta,
      width: "24px",
      height: "24px",
      link: "https://www.instagram.com/phybercare/",
    },
  ]);
  // Login page is already sized for 100%; opt out of the global app zoom
  useEffect(() => {
    document.documentElement.classList.add("no-app-zoom");
    return () => document.documentElement.classList.remove("no-app-zoom");
  }, []);
  useEffect(() => {
    const updateBg = () => {
      if (window.innerWidth >= 1024) {
        setBgImage(login_web);
      } else {
        setBgImage(login_mobile);
      }
    };

    updateBg(); // set on initial load
    window.addEventListener("resize", updateBg);
    return () => window.removeEventListener("resize", updateBg);
  }, []);

  useEffect(() => {
    let interval = null;
    if (currentView === "otp" && countdown > 0) {
      interval = setInterval(() => {
        setCountdown((countdown) => countdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [currentView, countdown]);

  const handleSendOTP = () => {
    if (email) {
      dispatch(sendOTP(email)).then((res) => {
        console.log("res=======>", res);

        // Check if the API call itself failed (network error, timeout, 500, etc.)
        if (!res?.payload || res.payload.status === "error") {
          const errorMsg =
            typeof res?.payload?.message === "string"
              ? res.payload.message
              : res?.payload?.message?.message || "Unable to send OTP. Please check your connection and try again.";
          setEmailError(errorMsg);
          return;
        }

        // Safely extract response data from either response.data or response directly
        const responseData = res.payload.message?.data || res.payload.message;

        if (responseData?.response_message === "Failure") {
          setEmailError(responseData.payload || "Failed to send OTP");
          console.log(responseData.payload);
        } else if (responseData?.payload) {
          // Store the role from the response
          const role = responseData.payload.role;
          setUserRole(role);
          console.log("User role:", role);

          setEmailError("");
          setCurrentView("otp");
          setCountdown(90);
        } else {
          setEmailError("User does not exist");
        }
      });
    } else {
      setEmailClassName(
        "block w-full pl-10 pr-3 py-3 border-1 border-[#DC2626] rounded-[12px] font-poppins text-[#171717] leading-5 bg-[#F8FAFC] placeholder-[#94A3B8] focus:outline-none focus:placeholder-[#334155] focus:ring-1 focus:ring-[#4B61FF] focus:border-[#4B61FF] mt-[20px] mb-[20px]"
      );
      setEmailError("*Please proceed with organizational Email ID ");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Handle the Enter key press
      handleSendOTP();
    }
  };

  const handleOTP = () => {
    console.log("otp", otpCode.join(""));
    let formData = {
      username: email,
      otp: otpCode.join(""),
      grant_type: "password",
    };
    dispatch(loginWithOtp(formData)).then((res) => {
      if (res?.payload?.status === "success") {
        let data = res.payload.message;
        console.log("data===>", data);

        // Store token and user role
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("userRole", userRole);

        // Redirect based on role
        if (userRole === "COUNSELLOR") {
          // Practitioner - redirect to practitioner app with token
          const practitionerUrl = process.env.REACT_APP_PRACT || "http://localhost:3001";
          window.location.href = `${practitionerUrl}?token=${data.access_token}`;
        } else if (userRole === "ADMIN") {
          // Admin users - go to admin dashboard
          window.location.href = "/dashboard";
        } else if (userRole === "CLIENT") {
          // Member/Client users - go to member dashboard
          window.location.href = "/member/dashboard";
        }
      } else {
        const errorDescription =
          res?.payload?.message?.error_description ||
          (typeof res?.payload?.message === "string" ? res.payload.message : null) ||
          "Invalid OTP or authentication failed.";
        console.log("error", errorDescription);
        setOTPError(errorDescription);
      }
    });
  };

  const handleOtpChange = (index, value) => {
    if (value.length <= 1) {
      const newOtpCode = [...otpCode];
      newOtpCode[index] = value;
      setOtpCode(newOtpCode);

      // Auto-focus next input
      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleOtpKeyDown = (index, e) => {
    // Handle backspace to go to previous input

    if (e.key === "Backspace" && !otpCode[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    } else if (e.key === "Enter") {
      if (otpCode.join("").length > 5) {
        handleOTP();
      }
    }
  };

  return (
    <div className="min-h-screen lg:h-screen flex flex-col lg:flex-row lg:overflow-hidden">
      {/* Mobile: Blue Section at Top, Desktop: Left Side */}
      <div
        className="w-full lg:w-1/2 bg-[#0b4f9f] bg-cover bg-center flex flex-col h-auto lg:h-full relative overflow-hidden flex-shrink-0"
        style={{
          backgroundImage: window.innerWidth >= 1024 ? "none" : `url(${login_mobile})`,
        }}
      >
        {/* Desktop View - Responsive Design.
            Undoes the app-wide desktop zoom (--app-zoom) so this panel renders at full size */}
        <div
          className="hidden lg:flex flex-col justify-between h-full p-5 lg:p-7 xl:p-8 relative z-10"
          style={{ zoom: "calc(1 / var(--app-zoom, 1))" }}
        >
          {/* Background Logo */}
          <div className="absolute inset-0 flex items-center justify-center opacity-10 pointer-events-none">
            <img
              src={back_logo}
              alt="Background Logo"
              className="w-auto h-auto max-w-full max-h-full object-contain"
            />
          </div>

          {/* Top Section: Logo & Heading */}
          <div className="flex flex-col items-start relative z-10 w-full">
            <div className="flex justify-start mb-2 lg:mb-3">
              <img
                src={left_side_logo}
                alt="Phyber Logo"
                className="h-7 lg:h-8 w-auto"
              />
            </div>
            <div className="font-semibold leading-tight text-xl lg:text-2xl xl:text-[28px] whitespace-pre">
              <p className="text-[#EAFF6C] mb-0">
                On-demand care,{" "}
              </p>
              <p className="text-white">anywhere!</p>
            </div>
          </div>

          {/* Bottom Section: Device Images & Features grouped at bottom */}
          <div className="flex flex-col items-start mt-auto relative z-10 w-full">
            {/* Device Images - Positioned down above checkmarks */}
            <div className="relative w-full max-w-[280px] lg:max-w-[320px] xl:max-w-[350px] mb-3" style={{ paddingBottom: "56%" }}>
              {/* Laptop - Main device on left */}
              <img
                src={laptop}
                alt="Laptop Dashboard"
                className="absolute h-auto object-contain"
                style={{
                  width: "98%",
                  left: "-3%",
                  top: "0%",
                  zIndex: 1,
                }}
              />
              {/* iPhone 2 - Middle phone (dark blue card), front */}
              <img
                src={iphone2}
                alt="Mobile App"
                className="absolute h-auto object-contain"
                style={{
                  width: "21%",
                  left: "69%",
                  top: "22%",
                  zIndex: 3,
                }}
              />
              {/* iPhone 1 - Right phone (yellow/light content), back */}
              <img
                src={iphone1}
                alt="Mobile App"
                className="absolute h-auto object-contain"
                style={{
                  width: "21%",
                  left: "89%",
                  top: "28%",
                  zIndex: 2,
                }}
              />
            </div>

            {/* Features at bottom */}
            <div className="grid grid-cols-2 gap-x-3 lg:gap-x-4 gap-y-1.5 lg:gap-y-2 w-full">
              <div className="flex items-center gap-1.5 lg:gap-2">
                <div className="w-4 h-4 lg:w-4.5 lg:h-4.5 bg-[#EAFF6C] rounded-full flex items-center justify-center flex-shrink-0">
                  <Check className="w-2.5 h-2.5 lg:w-3 lg:h-3 text-[#0B4F9F]" />
                </div>
                <span className="text-white font-poppins text-xs">Virtual Care</span>
              </div>
              <div className="flex items-center gap-1.5 lg:gap-2">
                <div className="w-4 h-4 lg:w-4.5 lg:h-4.5 bg-[#EAFF6C] rounded-full flex items-center justify-center flex-shrink-0">
                  <Check className="w-2.5 h-2.5 lg:w-3 lg:h-3 text-[#0B4F9F]" />
                </div>
                <span className="text-white font-poppins text-xs">On-premise Care</span>
              </div>
              <div className="flex items-center gap-1.5 lg:gap-2">
                <div className="w-4 h-4 lg:w-4.5 lg:h-4.5 bg-[#EAFF6C] rounded-full flex items-center justify-center flex-shrink-0">
                  <Check className="w-2.5 h-2.5 lg:w-3 lg:h-3 text-[#0B4F9F]" />
                </div>
                <span className="text-white font-poppins text-xs">OPD Care</span>
              </div>
              <div className="flex items-center gap-1.5 lg:gap-2">
                <div className="w-4 h-4 lg:w-4.5 lg:h-4.5 bg-[#EAFF6C] rounded-full flex items-center justify-center flex-shrink-0">
                  <Check className="w-2.5 h-2.5 lg:w-3 lg:h-3 text-[#0B4F9F]" />
                </div>
                <span className="text-white font-poppins text-xs">Phyber Care Store</span>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile View */}
        <div
          className="lg:hidden w-full h-[200px]"
          style={{
            backgroundImage: `url(${login_mobile})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
      </div>

      {/* Mobile: Form Section Below, Desktop: Right Side */}
      <div className="flex-1 lg:w-1/2 bg-white p-5 lg:px-8 xl:px-12 lg:py-6 flex flex-col justify-between h-auto lg:h-full lg:overflow-y-auto">
        {/* Main Content - Vertically Centered */}
        <div className="my-auto w-full py-4">
          <div className="max-w-[380px] lg:max-w-[410px] mx-auto w-full">
            {/* Logo */}
            <div className="flex justify-center mb-3 lg:mb-4">
              <img
                src={login_logo_new}
                alt="Phybercare Logo"
                className="w-12 h-12 lg:w-14 lg:h-14 object-contain rounded-2xl shadow-sm"
              />
            </div>

            {/* Welcome Text */}
            <div className="mb-1.5">
              <p className="text-xl lg:text-2xl font-semibold font-poppins text-[#171717] leading-tight whitespace-nowrap">
                Welcome to <span className="text-[#0B4F9F]">Phybercare!</span>
              </p>
            </div>

            {/* Subtitle */}
            <div className="mb-3 lg:mb-4">
              <p className="text-xs lg:text-sm font-semibold font-poppins text-[#1E1E1E] leading-normal">
                Your care journey begins here.
              </p>
            </div>

            {/* Form content (login or OTP) */}
            {currentView === "login" ? (
              <div className="flex flex-col gap-2.5">
                {/* Instruction Text */}
                <p className="text-xs lg:text-[13px] font-poppins text-[#4B4B4B] leading-normal mb-0.5">
                  Enter your email to proceed
                </p>

                {/* Email Input */}
                <div className="flex flex-col gap-3 lg:gap-3.5">
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Mail className="h-4 w-4 text-[#94A3B8]" />
                    </div>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Email Id"
                      className={`w-full h-10 lg:h-11 pl-9 pr-3 bg-[#F5F7FA] border-[1px] border-solid ${emailError ? "border-[#EC3234]" : "border-[#E7EDF5]"
                        } rounded-lg font-poppins text-sm text-[#1E1E1E] placeholder-[#4B4B4B] focus:outline-none focus:border-[#0B4F9F]`}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                  {emailError && (
                    <p className="text-[#DC2626] font-poppins text-xs -mt-1.5">
                      {emailError}
                    </p>
                  )}

                  {/* Get OTP Button */}
                  <button
                    onClick={handleSendOTP}
                    className="w-full h-10 lg:h-11 bg-[#0B4F9F] text-white border-0 rounded-lg font-poppins font-medium text-sm hover:opacity-95 transition-all"
                  >
                    Get OTP
                  </button>
                </div>

                {/* Separator */}
                <div className="w-full h-px bg-[#E7EDF5] my-1.5"></div>
              </div>
            ) : (
              <div className="space-y-3">
                <p className="text-xs lg:text-sm font-poppins text-[#334155]">
                  OTP sent to <span className="text-[#0B4F9F] font-medium">{email}</span>
                </p>

                {/* OTP Input */}
                <div className="flex gap-1.5 lg:gap-2 justify-between">
                  {[0, 1, 2, 3, 4, 5].map((index) => (
                    <input
                      key={index}
                      id={`otp-${index}`}
                      type="password"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={otpCode[index]}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                      maxLength={1}
                      className="w-9 h-9 lg:w-10 lg:h-10 text-center text-sm lg:text-base font-poppins text-[#1E1E1E] border-[1px] border-solid border-[#0B4F9F] bg-[#F5F7FA] rounded-lg focus:outline-none"
                      placeholder="0"
                    />
                  ))}
                </div>
                {otpError && (
                  <p className="text-[#DC2626] font-poppins text-xs">
                    {otpError}
                  </p>
                )}
                {/* Resend OTP and Timer */}
                <div className="flex justify-between items-center text-xs">
                  <button
                    onClick={() => setCountdown(90)}
                    className="text-[#0B4F9F] font-semibold hover:underline bg-transparent font-poppins"
                    disabled={countdown > 0}
                  >
                    Resend OTP?
                  </button>
                  <span className="text-red-500 font-medium font-poppins">
                    {Math.floor(countdown / 60)}:
                    {(countdown % 60).toString().padStart(2, "0")}
                  </span>
                </div>

                {/* Login Button */}
                <button
                  onClick={handleOTP}
                  className="w-full bg-[#0B4F9F] text-white border-0 h-10 lg:h-11 rounded-lg transition-all font-poppins font-medium text-sm hover:opacity-95"
                >
                  Login
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Bottom Footer Section */}
        <div className="mt-3 lg:mt-4 pt-1">
          <div className="max-w-[380px] lg:max-w-[410px] mx-auto w-full">
            <div className="text-center mb-2">
              <p className="text-[11px] lg:text-xs text-[#4B4B4B] font-poppins leading-normal">
                By logging in, you agree to our{" "}
                <a
                  href="https://phybercare.com/privacy"
                  target={"_blank"}
                  rel="noreferrer"
                  className="text-[#0B4F9F] font-semibold font-poppins no-underline hover:underline"
                >
                  Privacy Policy
                </a>{" "}
                and{" "}
                <a
                  href="https://phybercare.com/terms"
                  target={"_blank"}
                  rel="noreferrer"
                  className="text-[#0B4F9F] font-semibold no-underline hover:underline font-poppins"
                >
                  Terms of Use
                </a>
                .
              </p>
            </div>

            {/* Social Media Icons */}
            <div className="flex justify-center gap-4">
              {links.map((item) => {
                return (
                  <a
                    key={item.id}
                    href={item.link}
                    target={"_blank"}
                    rel="noreferrer"
                    className="text-[#0a66c2] hover:text-[#0B4F9F] transition-transform hover:scale-110"
                  >
                    <img src={item.image} className="w-4 h-4" alt="" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
